import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  loading: {
    position: "relative",
    left: -6,
  },
}));

export default useStyles;
